import { useContext, useState } from 'react';
import { getCookie, removeCookie } from './Cookie';
import parseJSONSGracefully from './parseJSONSGracefully';
import CookieNames from '../constants/CookieNames';
import AuthenticatedRouteLanguageContext from './AuthenticatedRouteLanguageContext';
import getUserPreferredLanguage from './i18n/getUserPreferredLanguage';

const useUserProfile = () => {
    const { setMessageLanguage } = useContext(AuthenticatedRouteLanguageContext);
    const cookieJson = getCookie(CookieNames.USER_PROFILE);
    const cookieObj = parseJSONSGracefully(cookieJson);

    const [userProfile, setUserProfile] = useState(cookieObj);

    const handleSwitchUser = () => {
        removeCookie(CookieNames.USER_PROFILE);
        setMessageLanguage(getUserPreferredLanguage());
        setUserProfile(null);
    };

    return [userProfile, handleSwitchUser];
};

export default useUserProfile;
